module.exports = __webpack_public_path__ + "img/poslat_zpravu.a366b7aa.svg";